<template  >
  <div >
    <header class="cfb">
      <img src="edukanji-logo.png" class="logo" alt="Edukanji" />
      <img src="@/assets/cafoscari-black.svg" class="logo-right" alt="Università Ca' Foscari Venezia" />
    </header>
    <v-toolbar>
      <v-tabs class='tab-style' v-model="tab">
         <v-tabs-slider color="white"></v-tabs-slider>
        <v-tab class='spa'  v-for="(item, index) in items" :key='index'>{{item}}</v-tab>
     
      </v-tabs>
    </v-toolbar>
    <v-main >
    <v-tabs-items v-model="tab" class='gr'>
      <v-tab-item class='page-wrapper'><Project></Project></v-tab-item>
      <v-tab-item class="page-wrapper"><Usage></Usage></v-tab-item>
      <v-tab-item class="page-wrapper"><Docs></Docs></v-tab-item>
    </v-tabs-items>
    </v-main>
    <v-footer flat dense dark app class="footer">
      <img src="@/assets/cafoscari-black.svg" class="cf-logo" alt="Università Ca' Foscari Venezia" />
      <div class="footer-box">
        <h5>
          <span style="padding-right:8px;">Responsabile scientifico, ricerca e sviluppo:</span><a href='https://www.unive.it/data/persone/7076506' target="_blank" rel="noopener noreferrer">Alessandro Mantelli<span class="sr-only"> (apre in nuova scheda)</span></a><br />Dipartimento
          di studi sull'Asia e sull'Africa Mediterranea<br />Università Ca' Foscari Venezia
        </h5>
      </div>
    </v-footer>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import Project from "@/components/mainpage/project.vue";
import Usage from "@/components/mainpage/usage.vue";
import Docs from "@/components/mainpage/docs.vue";

export default {
  data() {
    return {
      tab:null,
      cssProps: {
        backgroundImage: `url(${require("@/assets/kanji2.jpg")})`,
        backgroundSize: `200%`,
      },
      items:['il progetto','modi di utilizzo','bibliografia'],
    };
  },
  components: {
    Project,Usage,Docs
  },
};

    document.body.style.backgroundColor = "#efefef";
</script>

<style >

section {
  margin-bottom: 1em;
}
.gr {
  background:none;
}
.cfb {
  background: #ac0032;
}
.general-background {
  background: #eeeeee;
}
.logo {
  height: 60px;
  margin-top: 8px;
  margin-left: 16px;
}
.footer {
  background: #333333;
  display: flex;
}
.footer-box {
  width: 30em;
}
.cf-logo {
  height: 7em;
  filter: invert(100%);
  margin-top: 2em;
  margin-bottom: 2em;
  margin-right: 4em;
}

@media (max-height: 700px) {
  .cf-logo {
    height: 5em;
    filter: invert(100%);
    margin-top: 1em;
    margin-bottom: 1em;
  }
  
}
.logo-right {
  float:right;
  height:70px;
  padding:7px;
    filter: invert(100%);
}

h1 {
  font-family:"Poppins";
  font-size:62px;
  font-weight:normal;
  color:rgb(127, 14, 14);
  
  }
.text-content {
  color:#383838;
  background:white;
  padding:24px;
  border:1px solid #e4e4e4;
  border-radius:4px;
  font-size:large;
  line-height:1.7em;
}

.page-wrapper {
  background:#f0f0f0;
}
.tab-style {
  border-bottom:1px solid lightgrey;
}

.spa.v-tab.v-tab--active {
    color: #801800;
    border-bottom:2px color red;
}
.v-tabs-slider-wrapper {
  border-bottom:3px solid rgb(184, 0, 0);
}
@media (max-width:650px) {
h1 {
  font-family:"Poppins";
  font-size:32px;
  font-weight:normal;
  color:rgb(127, 14, 14);
  
  }
  .logo-right {
    display:none;
  }
  .spa {
    font-size:10px;
  }

    .cf-logo {
    height: 4em;
    filter: invert(100%);
    margin-top: 1em;
    margin-bottom: 1em;
    }
}

</style>
